import { Module, MutationTree, GetterTree } from 'vuex';
import { RootState, AudioState } from './types';

// Mutations
const ADD_RECORDING = 'addRecording';
const UPDATE_RECORDING_DURATION = 'updateRecordingDuration';
const SET_CURRENT_POSITION = 'setCurrentPosition';
const SET_CURRENT_RECORDING = 'setCurrentPlaying';
const SET_REQUESTED_POSITION = 'setRequestPosition';

// Getters
const RECORDING_DURATION = 'recordingDuration';
const CURRENT_RECORDING = 'currentRecording';
const CURRENT_POSITION = 'currentPosition';
const IS_PLAYING = 'isPlaying';
const REQUESTED_POSITION = 'requestedPosition';

const state: AudioState = {
  recordings: [],
  currentRecording: null,
  isPlaying: false,
  currentPosition: null,
  requestedPosition: 0
};

const mutations: MutationTree<AudioState> = {
  [ADD_RECORDING](state, id) {
    state.recordings.push({
      id,
      duration: 0
    });
  },
  [UPDATE_RECORDING_DURATION](state, payload: { id: string; duration: number }) {
    const recording = state.recordings.find(r => r.id === payload.id);
    if (recording) {
      recording.duration = payload.duration;
    }
  },
  [SET_CURRENT_RECORDING](state, id: string) {
    if (state.currentRecording !== id) {
      state.currentPosition = 0;
      state.requestedPosition = 0;
    }
    state.currentRecording = id;
  },
  [SET_CURRENT_POSITION](state, position: number) {
    state.currentPosition = position;
  },
  [SET_REQUESTED_POSITION](state, position: number) {
    state.requestedPosition = position;
  }
};

const getters: GetterTree<AudioState, RootState> = {
  [RECORDING_DURATION]: state => (id: string) => state.recordings.find(r => r.id === id).duration,
  [CURRENT_RECORDING]: state => state.currentRecording,
  [IS_PLAYING]: state => state.isPlaying,
  [CURRENT_POSITION]: state => state.currentPosition,
  [REQUESTED_POSITION]: state => state.requestedPosition
};

const audioModule: Module<AudioState, RootState> = {
  namespaced: false,
  state,
  mutations,
  getters
};

export default audioModule;

export {
  ADD_RECORDING,
  UPDATE_RECORDING_DURATION,
  SET_CURRENT_POSITION,
  SET_CURRENT_RECORDING,
  SET_REQUESTED_POSITION,
  RECORDING_DURATION,
  CURRENT_RECORDING,
  CURRENT_POSITION,
  IS_PLAYING,
  REQUESTED_POSITION
};
